import styled from 'styled-components';
import colors from '../../../helpers/colors';
import fonts from '../../../helpers/fonts';
import mediaQuery from '../../../helpers/mediaQuery';
import spacing, { spacingWithBorder } from '../../../helpers/spacing';
import { PrimaryCta, SecondaryCta } from '../../Cta';
import Image from '../../Image';
import RichText from '../../RichText';

export const Heading = styled.h2`
  ${fonts.headingSmall};
  margin-bottom: ${spacing(3)};
  margin-top: 0;
`;

export const ThreeCardVariantHeading = styled(Heading)`
  ${mediaQuery.tabletPortrait`
    margin-bottom: ${spacing(4)};
  `}
`;

export const ImageAndCtaCardContainer = styled.div`
  margin-bottom: ${spacing(4)};
  border: 1px solid ${colors.cardBorder};
  border-radius: ${({ theme }) => theme.cardRadius};
  display: flex;
  flex-direction: column;
  align-items: flex-start;
`;

export const ImageWrapper = styled.div`
  border-bottom: 1px solid ${colors.cardBorder};
  border-radius: ${spacingWithBorder(1, 1)} ${spacingWithBorder(1, 1)} 0 0;
  position: relative;
  overflow: hidden;
  height: 220px;
  width: 100%;

  ${mediaQuery.tabletLandscape`
    height: 244px;
  `}
`;

export const StyledImage = styled(Image)`
  height: 100%;
  width: 100%;
  object-position: 50% 50%;
  object-fit: cover;
`;

export const StyledPrimaryCta = styled(PrimaryCta)`
  margin-bottom: ${spacing(3)};
  margin-right: ${spacing(3)};

  ${mediaQuery.tabletLandscape`
    margin-bottom: ${spacing(4)};
    margin-right: ${spacing(6)};
  `}
`;

export const StyledSecondaryCta = styled(SecondaryCta)`
  margin-bottom: ${spacing(4)};
`;

export const ThreeCardVariantRichText = styled(RichText)`
  ${fonts.paragraph};
  margin-top: 0;
  margin-bottom: ${spacing(6)};

  ${mediaQuery.tabletPortrait`
    margin-right: ${spacing(6)};
    margin-bottom: ${spacing(3)};
  `}

  ${mediaQuery.tabletLandscape`
    margin-right: ${spacing(1)};
    margin-bottom: ${spacing(6)};
  `}
`;

export const StyledRichText = styled(RichText)`
  ${fonts.paragraph};
  margin-top: 0;
  margin-bottom: ${spacing(4)};

  ${mediaQuery.tabletLandscape`
    margin-bottom: ${spacing(6)};
  `}
`;

export const StyledText = styled.p`
  ${fonts.paragraph};
  margin-top: 0;
  margin-bottom: ${spacing(4)};

  ${mediaQuery.tabletLandscape`
    margin-bottom: ${spacing(6)};
  `}
`;

export const ThreeCardVariantText = styled.p`
  ${fonts.paragraph};
  margin-top: 0;
  margin-bottom: ${spacing(6)};

  ${mediaQuery.tabletPortrait`
    margin-right: ${spacing(6)};
    margin-bottom: ${spacing(3)};
  `}

  ${mediaQuery.tabletLandscape`
    margin-right: ${spacing(1)};
    margin-bottom: ${spacing(6)};
  `}
`;

export const ThreeCardVariantPrimaryCta = styled(PrimaryCta)`
  margin-bottom: ${spacing(4)};

  ${mediaQuery.tabletPortrait`
    margin-bottom: ${spacing(3)};
    margin-right: ${spacing(3)};
  `}

  ${mediaQuery.tabletLandscape`
    margin-right: 0;
  `}
`;

export const ThreeCardVariantSecondaryCta = styled(SecondaryCta)`
  margin-bottom: ${spacing(4)};

  ${mediaQuery.tabletPortrait`
    margin-bottom: ${spacing(3)};
  `}
`;

export const CtaWrapper = styled.div`
  margin: 0 ${spacing(3)};

  ${mediaQuery.tabletLandscape`
    margin: 0 ${spacing(4)};
  `}
`;

export const TextWrapper = styled.div`
  margin: ${spacing(3)};
  margin-bottom: 0;
  flex-grow: 1;

  ${mediaQuery.tabletLandscape`
    margin: ${spacing(4)};
    margin-bottom: 0;
  `}
`;
